module.exports = __webpack_public_path__ + "../resources/img/ic-others.ffa3dd7f.svg";